<template>
	<CarComponent />
</template>

<script>
import CarComponent from "@/components/CarComponent.vue";

export default {
	name: "App",
	components: {
		CarComponent,
	},
};
</script>

<style scoped></style>
